import { z } from 'zod';
import { FieldSchema } from '../common/field';
import { InitialUIElement } from '../initial-ui-element';
import { CommonOption } from '../common';

export const MULTISELECT_FIELD_ELEMENT_TYPE = 'multiselectfield' as const;
export const MultiSelectFieldElementType = z.literal(MULTISELECT_FIELD_ELEMENT_TYPE);

export const MultiSelectFieldParamsSchema = FieldSchema.extend({
  options: z.array(CommonOption),
});

export type TMultiSelectFieldParams = z.infer<typeof MultiSelectFieldParamsSchema>;

export const MultiSelectFieldElementSchema = InitialUIElement.extend({
  element: MultiSelectFieldElementType,
  params: MultiSelectFieldParamsSchema,
  valueDestination: z.string(),
});
